import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DashboardNavigation from '../components/DashboardNavigation.tsx';

export default function DashboardList() {
  return (
    <Box sx={{ p: '0 1.5rem 2.5rem', height: '100vh', width: '75vw', margin: '0 auto' }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography sx={{
          fontFamily: "'Syne', sans-serif",
          fontSize: 20,
          fontWeight: 600,
          color: '#1D9E75',
          mb: 3,
        }}>
          Dashboard List
        </Typography>
      </Box>
      <DashboardNavigation />
    </Box>
  );
}
